import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
export const useUserInfo = () => {
  return {
    userInfo: userInfoSync()
  };
};
export const useHasGate = gateName => {
  const {
    userInfo
  } = useUserInfo();
  const hasGate = useMemo(() => userInfo ? userInfo.gates.includes(gateName) : null, [userInfo, gateName]);
  return {
    hasGate
  };
};
export const useHasScope = scopeName => {
  const {
    userInfo
  } = useUserInfo();
  const hasScope = useMemo(() => userInfo ? userInfo.user.scopes.includes(scopeName) : null, [userInfo, scopeName]);
  return {
    hasScope
  };
};
export const useLimit = limitName => {
  const {
    userInfo
  } = useUserInfo();
  const limit = useMemo(() => userInfo ? userInfo.portal.limits[limitName] : null, [userInfo, limitName]);
  return {
    limit
  };
};